import { ManagerActionKind } from './actions';
export const managerReducer = (state, { type, payload }) => {
    switch (type) {
        case ManagerActionKind.ModifyManager: {
            return { ...payload };
        }
        default: {
            return state;
        }
    }
};
